/**
 * Shared event bus for auth-related events.
 * Both axios instances (api.js and httpClient.js) fire through here
 * so AuthContext is the single place that reacts to 401s.
 */

const unauthorizedListeners = new Set();

export function onUnauthorized(fn) {
    unauthorizedListeners.add(fn);
    return () => unauthorizedListeners.delete(fn);
}

export function fireUnauthorized() {
    unauthorizedListeners.forEach(fn => {
        try { fn(); } catch (_) {}
    });
}
